<template>

  <el-dialog :show-close="true" title="修改密码" :visible="dialogVisible" @close="bntClick(null)">
    <el-form :model="innerUser">
      <el-form-item label="新密码" :label-width="formLabelWidth">
        <el-input v-model="newPassWord" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="再次输入" :label-width="formLabelWidth">
        <el-input v-model="againPassword" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="原密码" :label-width="formLabelWidth">
        <el-input v-model="innerUser.verifyPassWord" autocomplete="off"></el-input>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="bntClick(null)">取 消</el-button>
      <el-button type="primary" @click="bntClick(innerUser)">确 定</el-button>
    </div>
  </el-dialog>

</template>

<script>

import toastUtils from "@/utils/toastUtils";
import stringUtils from "@/utils/stringUtils";
import consoleLog from "@/utils/consoleLog";

export default {
  name: "EditPassWordDialog",
  //完整接收props参数
  props: {
    dialogVisible: {
      type: Boolean,
      default: false //默认值
      // required:true //是必要的
    },
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    bntClick(value) {
      ///value === null表示取消和关闭按钮
      if (value === null) {
        this.$emit('editUserClick', value)
        return;
      }
      if (!this.newPassWord || !this.againPassword) {
        toastUtils.warning(this, "密码不能为空")
        return;
      }

      if (this.newPassWord !== this.againPassword) {
        toastUtils.warning(this, "两次密码不一致")
        return;
      }

      if (this.newPassWord === value.verifyPassWord) {
        toastUtils.warning(this, "新密码和原密码不能相同")
        return;
      }

      if (!stringUtils.isValidUsername(this.newPassWord)) {
        toastUtils.warning(this, "密码格式错误，需要6到12个字符，可以使用英文，数字和下划线，不能全是数字")
        return;
      }
      value.passWord = this.newPassWord
      this.$emit('editUserClick', value)
    }
  },
  data() {
    return {
      formLabelWidth: '120px',
      innerUser: {},
      againPassword: '',
      newPassWord: ''
    }
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (newValue === true) {
        this.innerUser = this.user;
      }
    }
  }

}
</script>

<style scoped>

</style>